"use client";
import { SectionItem } from "@/app/lib/features/home/home.types";
import Link from "next/link";
import FallbackImage from "../../elements/FallbackImage";
import { trackBrandClick } from "@/app/lib/tracking/interactions";
import { useTrackView } from "@/app/hooks/useTrackView";

interface BrandsSectionProps {
  brands?: SectionItem[];
  title?: string;
  icon?: string;
  sectionId?: number;
}

const BrandsSection = ({ brands, title, icon, sectionId }: BrandsSectionProps) => {
  const trackRef = useTrackView("section", sectionId);

  if (!brands || brands.length === 0) return null;

  return (
    <section ref={trackRef}>
      <h2 className="text-lg sm:text-xl font-medium mb-2 sm:mb-3 flex items-center gap-2">
        {icon && <span className="text-xl">{icon}</span>}
        {title || "Sana Özel Markalar"}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {brands.map((brand, i) => (
          <Link key={brand.id || i} href={brand.slug || "#"} className="group block" onClick={() => { if (brand.id) trackBrandClick(brand.id); }}>
            <div className="relative w-full overflow-hidden rounded-2xl border border-gray-200 bg-gray-100" style={{ aspectRatio: "560/218" }}>
              <FallbackImage
                src={brand.image}
                alt={brand.name || brand.title || "Marka"}
                fill
                className="object-cover group-hover:scale-[1.02] transition-transform duration-200 ease-out"
                fallbackClassName="object-contain opacity-60"
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                quality={70}
                loading="lazy"
              />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BrandsSection;
